import { Progress } from '@agro-club/agroclub-shared'
import { ResponsiveModal } from '../ResponsiveModal/ResponsiveModal'
import { AnalyticsPlaces } from '../../pages/Deal/analyticsPlaces'
import { BuyerWarehouseDTO } from 'modules/domain/types'
import { useTranslation } from 'react-i18next'
import { FormikProps } from 'formik'
import { FC } from 'react'
import { BuyerWarehouseFields } from './BuyerWarehouseFields'

type Props = {
  onClose: () => void
  formik: FormikProps<BuyerWarehouseDTO>
  progress: Progress
  boolDeliveryRadio?: boolean //Probably a temporary solution, since the new logistics have switched to BoolRadio
}
export const BuyerWarehouseForm: FC<Props> = ({ onClose, formik, progress, boolDeliveryRadio }) => {
  const { t } = useTranslation('address')

  return (
    <ResponsiveModal
      title={t('logisticsKR:details:unloadingModal:heading')}
      id={AnalyticsPlaces.BUYER_WAREHOUSE_EDIT_MODAL}
      onConfirm={() => formik.submitForm()}
      disabled={!formik.dirty}
      progress={progress}
      onClose={onClose}
      size="large"
    >
      <BuyerWarehouseFields formik={formik} boolDeliveryRadio={boolDeliveryRadio} />
    </ResponsiveModal>
  )
}
